import axios from "../http";
let module = "/sysPermission";

function selectMenuList(data){
	return axios.post(module + '/selectMenuList',data);
}
function addMenu(data){
	return axios.post(module + '/addMenu',data);
}
function updateMenu(data){
	return axios.post(module + '/updateMenu',data);
}
function deletePermission(data){
	return axios.post(module + '/deletePermission',data);
}
function updateMenuOrder(data){
	return axios.post(module + '/updateMenuOrder',data);
}
function addOperation(data){
	return axios.post(module + '/addOperation',data);
}
function selectOperationRootOrChildren(data){
	return axios.post(module + '/selectOperationRootOrChildren',data);
}
function updateOperation(data){
	return axios.post(module + '/updateOperation',data);
}

export default {
  selectMenuList,
  addMenu,
  updateMenu,
  deletePermission,
  updateMenuOrder
}



// WEBPACK FOOTER //
// ./src/api/modules/sysPermission.js